import { combineReducers } from 'redux';

import withdrawals from './withdrawals/reducer';
import pending from './pending/reducer';
import deposit from './deposit/reducer';

export default combineReducers({
  deposit,
  pending,
  withdrawals,
});
